import { RecommendForm } from "../../common/constants/forms/RecommendForm";
import { shareEmail, shareFacebook, shareUrl, shareWhatsapp } from "../../components/shareFunctions";
import { scrollRight } from "../../partials/scrollNav";
import { formState } from "../form/FormState";
import { GalleryTypology } from "./GalleryTypology";
import { loadPopupTypology, showAlert } from "./popUpTypology";
import { Typology } from "./Typology";
// Creating instances of the necessary classes
const galleryTypology = new GalleryTypology();
const typology = new Typology(formState);
const sendForm = new RecommendForm(formState);
// Exposing methods to the global window object for external usage
// instances of typology
window.showForm = typology.showForm;
window.showMap = typology.showMap;
window.showAllFeatures = typology.showAllFeatures;
window.showAlert = showAlert;
window.scrollRight = scrollRight;
// share functions
window.shareUrl = shareUrl;
window.shareWhatsapp = shareWhatsapp;
window.shareFacebook = shareFacebook;
window.shareEmail = shareEmail;
// gallery
window.openModalTypology = galleryTypology.openModalTypology;
window.closeModalGallery = galleryTypology.closeModalGallery;
// recommend
window.sendRecommend = sendForm.submitForm;
document.addEventListener('DOMContentLoaded', () => {
    typology.loadTypology();
    loadPopupTypology();
});
